import { adminHttpClient } from '../../commons/adminHttpClient'

const changePremiumEndDate = (productId: string, endDate: Date): Promise<any> => {
  return adminHttpClient.put(`/UpdatePremiumEndDate/${productId}?endDate=${endDate}`, '')
}

export default changePremiumEndDate
